import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-putus")({
  head: () => ({
    meta: [
      { title: "Kalkulator Hari Putus / Gamon - Berapa Hari Sejak Putus?" },
      { name: "description", content: "Hitung sudah berapa hari sejak kamu putus dengan dia. Lengkap tahun, bulan, hari - bantu move on dengan data." },
      { property: "og:title", content: "Kalkulator Hari Putus" },
      { property: "og:description", content: "Sudah berapa hari sejak putus? Cek dan move on." },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Lama Putus"
      intro="Sudah berapa hari sejak kamu putus dengan dia? Atau lagi gamon? Hitung di sini biar tahu seberapa jauh perjalanan move on kamu."
      dateLabel="Tanggal putus"
      verb="putus"
      iconKey="since-broken"
      storageKey="putus"
      path="/tools/hari-putus"
      body={[
        { heading: "Hitung hari putus / gamon", text: "Kadang move on butuh data konkret. Lihat berapa hari, bulan, dan tahun sudah berlalu sejak hubungan berakhir - sering jadi pengingat bahwa waktu memang menyembuhkan." },
        { heading: "Cara pakai", text: "Masukkan tanggal terakhir kalian masih bersama. Kami hitung sampai hari ini. Kamu juga bisa bagikan ke teman dekat untuk diskusi." },
        { heading: "Move on itu proses", text: "Tidak ada angka 'normal' untuk move on. Beberapa orang butuh berminggu-minggu, sebagian butuh tahunan. Kalkulator ini cuma alat refleksi - sisanya kamu yang jalanin." },
      ]}
      faq={[
        { q: "Apa itu gamon?", a: "Gamon (gagal move on) adalah kondisi belum bisa berhenti memikirkan mantan. Kalkulator ini bantu lihat 'sudah berapa lama sih sebenarnya'." },
        { q: "Bisakah saya reset tanggalnya?", a: "Bisa - tinggal pilih tanggal baru atau kosongkan. Tanggal lama akan otomatis tertimpa." },
        { q: "Apakah hitungan ini bantu move on?", a: "Bantu memberi perspektif. Sisanya butuh dukungan teman, kesibukan baru, atau profesional bila perlu." },
        { q: "Apakah data saya tersimpan di server?", a: "Tidak. Semua disimpan di browser kamu sendiri (localStorage)." },
        { q: "Bisa dibagikan ke teman?", a: "Bisa. Tombol 'Bagikan hasil' menyalin link yang sudah berisi tanggal putus." },
      ]}
    />
  ),
});